import React, { useState } from 'react';
import  {Link}  from 'react-router-dom';
import './login.css';

function Login(){
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [sucesso, setSucesso] = useState('');

  function Acessar(){
    alert(email);
  }

    return <div className="d-flex align-items-center text-center form-container">
      <form className="form-signin">
        <h1 className="h3 mb-3 fw-normal">Login</h1>

        <div className="form-floating">
          <input onChange={(e) => setEmail(e.target.value)} type="email" className="form-control" id="floatingInput" placeholder="E-mail" />
          <label for="floatingInput">E-mail</label>
        </div>
        <div className="form-floating">
          <input onChange={(e) => setSenha(e.target.value)} type="password" className="form-control" id="floatingPassword" placeholder="Senha" />
          <label for="floatingPassword">Senha</label>
        </div>
        
        <button onClick={Acessar} className="w-100 btn btn-lg btn-primary" type="button">Acessar</button>

        <div className="login-links mt-5">
          <Link to="/app/resetasenha" className="mx-3">Esqueci minha senha</Link>
          <Link to="/app/novocliente" className="mx-3">Criar uma conta</Link>
        </div>

        <p className="mt-5 mb-3 text-muted">&copy; Desenvolvido por iSolution</p>
      </form>
    </div>;
  }

export default Login;